__turbopack_context__.v({
  "value-prop-module-card": "value-prop-module-module-scss-module__2a4npq__value-prop-module-card",
  "value-prop-module-card-copy": "value-prop-module-module-scss-module__2a4npq__value-prop-module-card-copy",
  "value-prop-module-card-icon": "value-prop-module-module-scss-module__2a4npq__value-prop-module-card-icon",
  "value-prop-module-card-icon-container": "value-prop-module-module-scss-module__2a4npq__value-prop-module-card-icon-container",
  "value-prop-module-card-title": "value-prop-module-module-scss-module__2a4npq__value-prop-module-card-title",
  "value-prop-module-cards-container": "value-prop-module-module-scss-module__2a4npq__value-prop-module-cards-container",
  "value-prop-module-container": "value-prop-module-module-scss-module__2a4npq__value-prop-module-container",
});
